import { render, staticRenderFns } from "./OrganizationTableMobile.vue?vue&type=template&id=33703fb2"
import script from "./OrganizationTableMobile.vue?vue&type=script&lang=js"
export * from "./OrganizationTableMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports